import { render, staticRenderFns } from "./TeamEditorCard.vue?vue&type=template&id=50a9f16e"
import script from "./TeamEditorCard.vue?vue&type=script&lang=js"
export * from "./TeamEditorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports